import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ModuleService {
    /**
     * Get Date Filter Config
     * @param requestBody
     * @returns DateFilterConfig Successful Response
     * @throws ApiError
     */
    static getDateFilterConfigModuleDateFilterConfigPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/module/date_filter_config',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Bname Daterange
     * @param requestBody
     * @returns ModuleDateRange Successful Response
     * @throws ApiError
     */
    static getBnameDaterangeModuleBnameDaterangePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/module/bname_daterange',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Menu Mapping
     * @param requestBody
     * @returns CogsMenuMapping Successful Response
     * @throws ApiError
     */
    static getMenuMappingModuleCogsGetMenuMappingPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/module/cogs/get/menu_mapping',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Menu Mapping
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static setMenuMappingModuleCogsSetMenuMappingPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/module/cogs/set/menu_mapping',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
